import { render, staticRenderFns } from "./ItensMenu.vue?vue&type=template&id=6434e68e&"
import script from "./ItensMenu.vue?vue&type=script&lang=js&"
export * from "./ItensMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports